import { render, staticRenderFns } from "./NonCustom.vue?vue&type=template&id=730b0f3d"
import script from "./NonCustom.vue?vue&type=script&lang=js"
export * from "./NonCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports